import { useRestrictionById } from '@/api/restrictions/queries';
import { useSearchParams } from '@starsoft/common/hooks';

export function useRestrictionsForm() {
  const search = useSearchParams();
  const id = search.get('id');
  const restrictionCategory = search.get('restrictionCategory');
  const isCreating = !id;

  const useRestrictionByIdQuery = useRestrictionById({
    id: Number(id),
  });

  return {
    isCreating,
    id,
    useRestrictionByIdQuery,
    restrictionCategory,
  };
}
